var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list',[_c('v-list-item',{staticClass:"px-2 py-5"},[_c('div',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.handleMenuItemClick()}}},[_c('img',{attrs:{"height":"45","src":_vm.enterpriseUser ? require('@/assets/AirBolt_Enterprise_Logo.png') : require('@/assets/airbolt-logo.png')}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }